import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { slideInLeft, slideInRight, slideOutLeft, slideOutRight } from 'src/utilities/animation';
import { SkeletonServiceService } from 'src/services/skeleton/skeleton.service';
import { OfferedLanguage } from 'src/models/language.model';
import { ConfigService } from 'src/services/config/config.service';
import { NavPartner } from 'src/models/partners';
import { AsyncPipe} from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ThemeService } from 'src/services/theme/theme.service';
import { RouterModule } from '@angular/router';
import { UserManagerService } from 'src/services/userManager/user-manager.service';
import { LegalIcon, SocialMedia } from 'src/models/partner-socials.model';
import { LanguageService } from 'src/services/language/language.service';
import { ModalService } from 'src/services/modal-service/modal.Service';

@Component({
  selector: 'app-nav-menu',
  standalone: true,
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.scss'],
  imports: [AsyncPipe, TranslateModule, RouterModule],
  animations: [slideOutLeft, slideOutRight, slideInLeft, slideInRight],
})
export class NavMenuComponent implements OnInit {
  @Input() partners: NavPartner[] = []
  @Output() closeSideMenu: EventEmitter<boolean> = new EventEmitter(false);
  @Output() langChange: EventEmitter<string> = new EventEmitter();
  // selectedLanguage: OfferedLanguage;
  // selectedLanguage: Observable<OfferedLanguage>;
  socialIcons!: SocialMedia;
  legalIcons!: LegalIcon[];
  paymentProviders: NavPartner[] = [];
  modalState = "leave"
  constructor(
    private configService: ConfigService,
    private skeletonService: SkeletonServiceService,
    private themeService: ThemeService,
    private userManagementService: UserManagerService,
    private modalService: ModalService,
    private languageService: LanguageService,
    private translate: TranslateService) {
    // this.selectedLanguage = skeletonService.appLanguage$.asObservable()
  }

  get languagesOffered(): OfferedLanguage[] {
    return this.languageService.offeredLanguages;
  }

  /** Hidden when the host locked the language (iframe + valid ?lang=). */
  get showLanguageSwitcher(): boolean {
    return !this.languageService.languageLocked && this.languagesOffered.length > 1;
  }

  get theme() {
    return this.themeService.getTheme();
  }

  get isMobile() {
    return this.skeletonService.isMobile();
  }

  get headerNav() {
    return this.theme.headerNavMenu.filter((nav) => nav.channel.includes('mobile'));
  }

  get newPartners() {
    return this.configService.NewPartners
  }

  get footerNav() {
    return this.theme.footerNavMenu;
  }

  get selectedLanguage() {
    return this.skeletonService.appLanguage$.asObservable();
  }

  get showUserManagementIcon() {
    return this.theme.hasOwnProperty('userManagement') && !!this.theme.userManagement && this.theme.userManagement.env === 'external';
  }

  get currentYear() {
    return new Date().getFullYear();
  }

  ngOnInit() {
    if(this.isMobile) {
      this.modalState = "enter";
    }
    this.paymentProviders = this.theme.partners;
    this.legalIcons = this.theme.legalIcons! || [{ src: '', alt: '+18' }];
  }

  getNavLink(nav: any): string {
    // Replace with your actual mobile detection logic

    if (this.isMobile && nav.url === '/support') {
      return '/support/nav';
    }
    return nav.url;
  }

  openPartner(partner: NavPartner) {
    this.configService.open(partner);
    if(this.isMobile){
      this.closeMenu();
    }
  }

  closeMenu(){
    this.closeSideMenu.emit(true);
  }

  selectLanguage(lang: OfferedLanguage) {
    this.skeletonService.switchLanguage(lang.code);
    // this.langChange.emit(lang.code);
  }

  gotoUrl(){
    let url = this.theme.userManagement?.url +'?' + this.userManagementService.setLoggedInUserUrlParams();
    url = this.configService.decorateUrl(url);
    window.location.href = url;
  }

  downloadApkAlert() {
    this.modalService.openDownloadDialogBox(
      "download_mobile_app.title",
        this.translate.instant("download_mobile_app.confirm_question", {appName: this.theme.mobileAppOpts.name}),
      []
    )
  }
}
